module.exports = __webpack_public_path__ + "img/adobe-vs-magento-img-2.148387f5.webp";